import React from "react";
import styled from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

const JunoError = styled.div`
  margin: 0;
  padding: 2px 0;
  clear: both;
  color: var(--juno-color-red);

  font-size: var(--juno-font-size-body-sm);
  line-height: normal;
  ${mediaQueries.md} {
    font-size: var(--juno-font-size-body-md);
  }

  ${(props) => props.loginError && "margin-bottom: 1rem; max-width: 38rem;"};
`;

function ErrorMessage(props) {
  return <JunoError {...props}>{props.children}</JunoError>;
}

export default ErrorMessage;
